import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'spr-coach-profile-biography',
	templateUrl: './coach-profile-biography.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoachProfileBiographyComponent {
	@Input() public biography: string;

	constructor() {}
}
